import { store } from '../../../../store';
import { useSelector } from 'react-redux';

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const isQualityEnabled = () => {
    try {
        return !!JSON.parse(localStorage.user_id).factoryData
            .isQualityEnabled;
    } catch (e) {
        return false;
    }
};

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const isQualityEnabledAllowed = () => {
    try {
        const state = store.getState();
        return (
            state.settings.isQualityEnabled
        );
    } catch (e) {
        return false;
    }
};

/** @returns {boolean}  */
export const useQualityEnabled = () =>
    useSelector(({ settings }) => settings.isQualityEnabled);